import { useNavigate, useLocation } from 'react-router-dom'

/** Clean, SEO-friendly route for each of the original page tokens. */
export const paths = {
  home: '/',
  about: '/about',
  serve: '/who-we-serve',
  programs: '/programs',
  youngAdults: '/programs/young-adults',
  adults: '/programs/adults',
  keys: '/programs/keys',
  model: '/housing-model',
  refer: '/refer',
  outcomes: '/outcomes',
  involved: '/get-involved',
  partner: '/partner',
  give: '/give',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms',
  director: '/director',
  team: '/team',
  resources: '/resources',
} as const

/** Route tokens that hide the pre-footer "close band" (mirrors the original `showClose`). */
export const noCloseBand = ['/about', '/team', '/director', '/privacy', '/terms', '/resources']

export const memberPath = (key: string) => `/team/${key}`

/**
 * Navigation handlers named to match the original template's `{{ goX }}` values,
 * so section markup ports over unchanged. Scroll-to-top on navigate is handled
 * globally in the Layout.
 */
export function useGo() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const es = pathname === '/es' || pathname.startsWith('/es/')
  // Stay within the current language: prefix /es when browsing the Spanish site.
  const go = (p: string) => navigate(es ? (p === '/' ? '/es' : '/es' + p) : p)
  return {
    goHome: () => go(paths.home),
    goAbout: () => go(paths.about),
    goServe: () => go(paths.serve),
    goPrograms: () => go(paths.programs),
    goYoungAdults: () => go(paths.youngAdults),
    goAdults: () => go(paths.adults),
    goKeys: () => go(paths.keys),
    goModel: () => go(paths.model),
    goRefer: () => go(paths.refer),
    goOutcomes: () => go(paths.outcomes),
    goInvolved: () => go(paths.involved),
    goPartner: () => go(paths.partner),
    goGive: () => go(paths.give),
    goContact: () => go(paths.contact),
    goPrivacy: () => go(paths.privacy),
    goTerms: () => go(paths.terms),
    goDirector: () => go(paths.director),
    goTeam: () => go(paths.team),
    goResources: () => go(paths.resources),
    goMember: (key: string) => go(memberPath(key)),
  }
}
